// extracted by mini-css-extract-plugin
module.exports = {"bstRow":"AgingList_bstRow__1cgBd","header":"AgingList_header__2qNBa","blueCell":"AgingList_blueCell__1CEs4"};